import styled from 'styled-components'

export const StBadge = styled.span`
  display: flex;
  font-size: ${({ theme }) => theme.Typography.BodyMediumBold}px;

  min-width: 1.4em;
  width: 1.4em;
  height: 1.4em;
  border-radius: 50%;
  /* number size and position */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  color: ${({ theme }) => theme.Colors.Background.White};
  background-color: ${({ theme }) => theme.Colors.Status.Error};
`
